module.exports = __webpack_public_path__ + "img/BY-NC-ND.89a49230.png";